import { render } from "./cloudStorageManage.vue?vue&type=template&id=557d994e&scoped=true"
import script from "./cloudStorageManage.vue?vue&type=script&lang=js"
export * from "./cloudStorageManage.vue?vue&type=script&lang=js"

import "./cloudStorageManage.vue?vue&type=style&index=0&id=557d994e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557d994e"]])

export default __exports__